export const SEASON_DEFAULT = "default";
export const SEASON_HALLOWEEN = "halloween";

// Inclusive through 3 Nov 2026, local time. From 4 Nov the site uses the normal season.
const HALLOWEEN_ENDS = new Date(2026, 10, 4, 0, 0, 0, 0);

export function getActiveSeason(date = new Date()) {
  return date < HALLOWEEN_ENDS ? SEASON_HALLOWEEN : SEASON_DEFAULT;
}
